import { useTranslation } from 'react-i18next';
import { useNavigation } from '~/Hooks';

import { ILocationWithStatus } from '~/Models/interfaces/Location.model';
import { IMenuAction } from '~/Models/interfaces/menuAction.models';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';

export const useProviderLocationsActions = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  const actions: (item: ILocationWithStatus) => IMenuAction[] = (item) => {
    const items: IMenuAction[] = [
      {
        name: t('app.edit'),
        onClick: () => {
          navigate(routeReplacer(Route.PROVIDER_LOCATIONS_EDIT, { id: item.id }));
        },
      },
      {
        name: t('settings.locations.copy'),
        onClick: () => {
          navigate(routeReplacer(Route.PROVIDER_LOCATIONS_COPY, { id: item.id }));
        },
      },
    ];

    return items;
  };

  return { actions };
};
